// Assets
import LinkIcon from '../../assets/link-icon.png';

// Types
import { UserDetailsRes, UserGrant } from '../../types/types';

// Components
import { RedirectLink } from './RedirectLink';
import Text from './Text';

// Component for rendering each grant
const GrantItem = ({ grant }: { grant: UserGrant }) => (
  <div className="grant-sub-container">
    <div>
      <Text className="mp-grant-organization">{grant.organization}</Text>
      <Text className="mp-grant-number">{grant.grant_number}</Text>
    </div>
    <Text className="mp-grant-description">{grant.description}</Text>
  </div>
);

// Component for rendering the grants list
const GrantsList = ({ grants }: { grants: UserGrant[] | undefined }) => (
  <>
    {grants?.map((grant: UserGrant, index: number) => (
      <div key={index}>
        <GrantItem grant={grant} />
        {index < grants.length - 1 && <hr className="mp-citations-hr" />}
      </div>
    ))}
  </>
);

// Main Grants component
const Grants = ({ userInfo }: { userInfo: UserDetailsRes }) => {
  const hasGrants = userInfo?.grants && userInfo.grants.length > 0;

  return (
    <div>
      <div className="grants">
        <Text className="my-profile-grants-title">Grants</Text>
      </div>
      {hasGrants && (
        <>
          <GrantsList grants={userInfo?.grants} />
          <div className="more-link">
            <a
              href={userInfo.google_scholar_url}
              target="_blank"
              rel="noopener noreferrer"
            >
              <RedirectLink text="See more" icon={LinkIcon} />
            </a>
          </div>
        </>
      )}
    </div>
  );
};

export default Grants;
